import { render } from "./expertSettings.vue?vue&type=template&id=7cc6b924&ts=true"
import script from "./expertSettings.vue?vue&type=script&lang=ts"
export * from "./expertSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__